define('lq/validations',[
    'when'
],function (when) {
    'use strict';

    var runValidation = function (validation, piping, triggerEvent, optionalCurrentContextValue) {
        if(!validation || validation.rules.length === 0) return when(true);
        
        return when.reduce(validation.rules, function (globalValidationResult, validationRule) {
            var evaluator = piping.conditions.getConditionEvaluator(validationRule.condition);

            return evaluator.evaluate(piping, true, null, optionalCurrentContextValue)
                .then(function (executionData) {
                    if (!executionData.conditionResult) {
                        var invalidatedEventData = validationRule.eventing['invalidated'];
                        if (invalidatedEventData.enabled) {
                            triggerEvent(invalidatedEventData.raisedEventName);
                        }
                        return false;
                    } else {
                        var validatedEventData = validationRule.eventing['validated'];
                        if (validatedEventData.enabled) {
                            triggerEvent(validatedEventData.raisedEventName);
                        }
                        return globalValidationResult;
                    }
                });
        }, true);
    };

    return {

        runValidation: runValidation

    };
});
